import { CoordinationClient, CoordinationClientType } from '@atlassiansox/engagekit-ts';
import { getConfluenceWorkspaceId, getCloudId } from '@databases/database-state';
import { useMemo } from 'react';

export const useCoordinationClient = (): CoordinationClientType | undefined => {
  const cloudId = getCloudId();

  const disableEngagementForTests =
    sessionStorage.getItem('confluence.disable-engagement-for-tests') ||
    localStorage.getItem('confluence.disable-engagement-for-tests');

  const client = useMemo(() => {
    if (!cloudId) {
      return undefined;
    }

    return disableEngagementForTests !== null
      ? {
          start: async () => disableEngagementForTests === 'enabled',
          stop: async () => disableEngagementForTests === 'enabled',
        }
      : new CoordinationClient({
          cloudId,
          stargateUrl: '/gateway/api',
          workspaceId: getConfluenceWorkspaceId(),
        });
  }, [cloudId, disableEngagementForTests]);

  return client;
};
